import clsx from 'clsx';
import {
    Divider as PrimeDivider,
    type DividerProps as PrimeDividerProps,
} from 'primereact/divider';
import { type ReactNode } from 'react';

export type DividerProps = PrimeDividerProps;

export function Divider({ className, ...props }: DividerProps): ReactNode {
    return (
        <PrimeDivider
            {...props}
            className={clsx('guardian-divider', className)}
        />
    );
}
